/**
 * Decorator that queues async method calls.
 * Calls to async methods will be executed after previous calls complete.
 *
 * @param target Class
 * @param propertyKey Method name
 * @param descriptor Property descriptor
 */
export function queueAsyncMethodCalls(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  // Call pipeline
  let pipeline: Promise<any> = Promise.resolve();

  // Object method to queue
  const queuedFn = target[propertyKey];

  /**
   * Queuing function.
   * Queues calls to queuedFn.
   *
   * @param args
   * @returns Promise<any>
   */
  descriptor.value = async function (...args: any[]) {
    pipeline = pipeline.then(() => {
      return queuedFn.apply(this, args);
    });

    return pipeline;
  };
}
